import { isAfter } from 'date-fns'
import { isEmpty } from 'lodash'
import { getFormValues, initialize } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { select } from 'redux-saga/effects'
import { callFetch } from '../../../actions/fetch'
import {
  createInvoice,
  ICreateInvoice,
  ICreateInvoiceFromForm,
} from '../../../actions/invoices/createInvoice'
import invoiceAccepted from '../../../actions/invoices/invoiceAccepted'
import toggleInvoiceLoading from '../../../actions/invoices/toggleInvoiceLoading'
import fireToastError from '../../../actions/toasts/fireToastError'
import { isSafari } from '../../../components/DetectBrowser/DetectBrowser'
import { driver } from '../../../database/localStorage'
import { CredentialsStorage } from '../../../database/localStorage/names'
import i18n from '../../../i18n'
import { IInvoice } from '../../../models/Invoice'
import { default as requestCreateInvoice } from '../../../models/Invoice/createInvoice'
import { LicenseType } from '../../../models/License'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'
import {
  getModalUpdateReservationIsOpen,
  getUpdateModalReservationId,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { InvoiceActions } from '../../../reducers/invoice/actionNames'
import { getInvoiceReservationId } from '../../../reducers/invoice/getInvoice'
import {
  getInvoiceLicense,
  getLicense,
} from '../../../reducers/userAccount/selectors/license'
import { ActionNames } from '../../../utils/FetchActionsName'
import fetchActionsName from '../../../utils/FetchActionsName/fetchActionsName'
import { createReservation } from '../createEvent'
import { validate } from '../Reservation/validate'
import { updateReservation } from '../updateEvent'
import { getPanelUrlForEnv } from '../../../utils/ApiUrl'
import edit from '../../../actions/toasts/icons/edit'

function* create(action: ICreateInvoice) {
  try {
    yield Effects.put(toggleInvoiceLoading(true))
    const actionNames = fetchActionsName(ActionNames.CreateInvoice)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, requestCreateInvoice),
      ),
    ])

    const invoice: IInvoice = yield Effects.call(service, action.id)

    if (invoice.link) {
      yield Effects.put(invoiceAccepted(invoice, action.id, true))
    } else {
      const invoiceLink = yield select(getInvoiceLicense)
      const goToInvoice = () => {
        const w = window.open(invoiceLink.link, '_blank')
        //https://api-rc.bed-booking.com/invoice/login?p=bb-mateuszpiwowarskiinvoices4656&x=zA6nIegdkDyGAoTRCcJu
        //getdomain from link between p= and &
        let domain = invoiceLink.link.split('p=')[1]
        domain = domain.split('&')[0]
        const url = `https://${domain}.invoice.bed-booking.com/account/edit#section_documents`
        //redirect new window afrer 1s
        setTimeout(() => {
          w.location.href = url
        }, 500)
      }
      yield Effects.put(
        fireToastError(
          i18n.t('invoice_toast_wrong_doc_text'),
          15000,
          'Event',
          'changeInvoice',
          true,
          i18n.t('invoice_toast_wrong_doc_button'),
          goToInvoice,
          edit(),
        ),
      )
    }

    yield Effects.put(toggleInvoiceLoading())
  } catch (e) {
    yield Effects.put(toggleInvoiceLoading())
    console.error(e)
    yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
  }
}

function* createFromForm(action: ICreateInvoiceFromForm) {
  const premium = yield Effects.select(getLicense(LicenseType.LICENSE_INVOICE))

  if (premium && premium.link && isAfter(premium.license, new Date())) {
    yield Effects.put(toggleInvoiceLoading(true))

    const modalUpdate = yield Effects.select(getModalUpdateReservationIsOpen)

    if (modalUpdate) {
      const id = yield Effects.select(getUpdateModalReservationId)
      const eventValues = yield Effects.select(
        getFormValues('update_reservation'),
      )

      const errors = yield* validate('update_reservation')

      if (!isEmpty(errors)) {
        yield Effects.put(toggleInvoiceLoading())
        if (isSafari() && action.reference) {
          action.reference.close()
        }
        return
      }

      yield* updateReservation(id, eventValues)
      yield Effects.put(createInvoice(id))
      yield Effects.put(initialize('update_reservation', eventValues, false))
    } else {
      const eventValues = yield Effects.select(
        getFormValues('create_reservation'),
      )

      const errors = yield* validate('create_reservation')

      if (!isEmpty(errors)) {
        yield Effects.put(toggleInvoiceLoading())

        if (isSafari() && action.reference) {
          action.reference.close()
        }

        return
      }

      const reservationId = yield Effects.select(getInvoiceReservationId)
      if (reservationId) {
        yield* updateReservation(reservationId, eventValues)
        yield Effects.put(createInvoice(reservationId))
      } else {
        yield Effects.spawn(createReservation, {
          ...eventValues,
          invoiceIssued: true,
        })
        const event = yield Effects.take(EventActions.EventWasCreated)
        yield Effects.put(createInvoice(event.event.id))
      }
      yield Effects.put(initialize('create_reservation', eventValues, false))
    }
  } else {
    const key = driver.getItem(CredentialsStorage.AccessToken, '')
    //const EnvUrl = getApiUrlForEnv()
    const uri = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
    window.open(uri, '_blank')
  }
}

export default function*() {
  yield Effects.takeEvery(InvoiceActions.Create, create)
  yield Effects.takeEvery(InvoiceActions.CreateFromForm, createFromForm)
}
